const routes = {
  createDeliveryType: 'delivery-type',
  getDeliveryTypes: 'delivery-type',
  getDeliveryTypeById: 'delivery-type/',
  updateDeliveryType: 'delivery-type/',
  deleteDeliveryType: 'delivery-type/',
};

export default routes